"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
const react_1 = __importDefault(require("react"));
const Text_1 = require("../Text");
function ProgressBar({ testId }) {
    return (react_1.default.createElement("div", { className: "block", "data-testid": testId },
        react_1.default.createElement("div", { className: "progress-bar" }),
        react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.BODY_S, className: "mt-4 ml-1", subdued: true }, "Gathering data. This process should only take a couple of minutes. Please wait...")));
}
exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map